module.exports = __webpack_public_path__ + "img/guangshanyundongLeft.66c76795.gif";